import { Component } from '@angular/core';

@Component({
    selector: 'base-layout',
    templateUrl: './baseLayout.template.html',
    styleUrls: ['./baseLayout.styles.scss'],
    standalone: false
})

export class BaseLayout {}
